module.exports = __webpack_public_path__ + "static/helvetica-bold-19f8d00e507858a750cc961c7e45562c.otf";